/**
 * Seller intake submit UI states and result copy (Sell Your Car M7).
 */
export const SELLER_SUBMIT_UI_STATES = Object.freeze({
  IDLE: "idle",
  EDITING: "editing",
  SUBMITTING: "submitting",
  SUCCESS: "success",
  VALIDATION_ERROR: "validation_error",
  NETWORK_ERROR: "network_error",
  SERVICE_ERROR: "service_error",
  DUPLICATE: "duplicate",
  SPAM_REJECTED: "spam_rejected",
  RATE_LIMITED: "rate_limited",
  UNKNOWN_ERROR: "unknown_error",
});

export const SELLER_SUBMISSION_RESULT_COPY_ES = Object.freeze({
  successTitle: "Recibimos la información de tu vehículo",
  successBody:
    "Gracias. El equipo de AutoMapa revisará los datos y podrá contactarte para confirmar detalles antes de preparar una publicación.",
  successStepReview: "Revisaremos la información enviada.",
  successStepContact: "Si necesitamos más detalles, te contactaremos.",
  successStepNoAutoPublish: "La publicación no aparecerá automáticamente.",
  successPhotosUploaded: "Recibimos tus fotos para revisión.",
  successPhotosPartial:
    "Recibimos tu solicitud, pero algunas fotos no se pudieron subir. Nuestro equipo puede contactarte para completarlas.",
  successPhotosSkipped: "Puedes enviar fotos más adelante si nuestro equipo te lo solicita.",
  browseVehicles: "Ver carros en venta",
  submitAnother: "Enviar otro vehículo",
  validationErrorTitle: "Revisa los datos",
  validationErrorBody: "Revisa los datos del vehículo e intenta nuevamente.",
  networkErrorTitle: "No pudimos conectar",
  networkErrorBody: "Revisa tu conexión e intenta nuevamente.",
  serviceErrorTitle: "No pudimos enviar la información",
  serviceErrorBody: "Ocurrió un problema al procesar la solicitud. Intenta nuevamente en unos minutos.",
  duplicateTitle: "Ya recibimos una solicitud similar",
  duplicateBody:
    "Parece que ya enviaste información parecida recientemente. Si necesitas corregir algo, espera un momento e intenta nuevamente.",
  spamRejectedTitle: "No pudimos procesar la solicitud",
  spamRejectedBody: "Intenta nuevamente más tarde o revisa que la información esté completa.",
  rateLimitedTitle: "Demasiados intentos",
  rateLimitedBody: "Has enviado varias solicitudes en poco tiempo. Intenta nuevamente más tarde.",
  retry: "Intentar de nuevo",
});

export const SELLER_BROWSE_VEHICLES_HREF = "/comprar/carros-usados";
